module.exports = __webpack_public_path__ + "static/img/right-door-wall_256.95d4656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-door-wall_256.png
// module id = eOA4
// module chunks = 0